<div class="global d-flex justify-content-center align-items-center align-items-center w-100 h-100">
    <div class="spinner">
        <!-- <ng-lottie [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie> -->
    </div>
</div>
    